import React, { Fragment } from "react";
import { inject, observer } from "mobx-react";
import * as Sentry from "@sentry/react";

import { styled } from "../../../stitches.config";

import NoSSR from "src/helpers/NoSSR";
import NextArticle from "src/redesign/components/NextArticle";

@inject("ArticleStore", "CategoryStore", "UIStore")
@observer
export default class ReadMoreArticles extends React.Component {
  render() {
    const { isDarkMode, articles } = this.props;

    const sponsoredArticles = articles
      .filter(article => article.material_partnera === true)
      .sort(() => Math.random() - 0.5);

    const regularArticles = articles.filter(
      article => article.material_partnera !== true
    );

    const sortedArticles = [...sponsoredArticles, ...regularArticles];

    return (
      <NextArticleWrapperBox isDarkMode={isDarkMode} className="next-article-wrapper-box">
        <NextArticleWrapper isDarkMode={isDarkMode}>
          <div class="container">
            <p class="header">Czytaj więcej</p>
            <NoSSR fallback={null}>
              <Sentry.ErrorBoundary fallback={<div className="text-center">Wystąpił problem z załadowaniem artykułów</div>}>
                {sortedArticles.map((item, index) => (
                  <NextArticle
                    key={index}
                    articleData={item}
                    adslotNum={index + 4}
                    dataAnalyticsName={"infinite-scroll-article-" + index}
                    changeLink
                  />
                ))}
              </Sentry.ErrorBoundary>
            </NoSSR>
          </div>
        </NextArticleWrapper>
      </NextArticleWrapperBox>
    );
  }
}

export const NextArticleWrapperBox = styled("article", {
  width: "100%",
  backgroundColor: "$grayscale0",
  minHeight: '1500px',
});

export const NextArticleWrapper = styled("article", {
  margin: "0 auto",
  backgroundColor: "$grayscale0",
  color: "$grayscale100",
  padding: "32px 0px 24px 0px",
  "@bp4": {
    padding: "80px 0px 48px 0px"
  },
  ".container > :last-child": {
    "div": {
      borderWidth: "0px !important"
    }
  },
  ".header": {
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 700,
    margin: "0",
    "@bp4": {
      fontSize: "38px",
      lineHeight: "42px"
    }
  }
});